import { LocalizationSerializer } from "@serializers/localization"
import { CareersValueSerializer } from "@serializers/careers-value"
import { CareersBenefitSerializer } from "@serializers/careers-benefit"
import { CareersPersonSerializer } from "@serializers/careers-person"

import { BaseHttpProvider } from "./base-http.provider"

import type { LanguageISO } from "./types"

export class VacanciesProvider extends BaseHttpProvider {
  // The older careers endpoint. Kept as a fallback for any key that has not been
  // moved to CareersPage yet, so the page cannot break mid migration.
  async getCareersTemplates(lang: LanguageISO) {
    const data = await this.execute({
      uri: "/vacancies-page",
      query: {
        lang,
      },
    })

    return {
      templates: data?.templates.map((template) =>
        LocalizationSerializer(template),
      ),
    }
  }

  // The newer careers endpoint, a localized single type. It holds everything the
  // careers page shows: the three repeating lists as components, and the rest as
  // key and template pairs.
  async getCareersPage(lang: LanguageISO) {
    const data = await this.execute({
      uri: "/careers-page",
      query: {
        lang,
      },
    })

    return {
      values: (data?.values ?? []).map((value) =>
        CareersValueSerializer(value),
      ),
      benefits: (data?.benefits ?? []).map((benefit) =>
        CareersBenefitSerializer(benefit),
      ),
      people: (data?.people ?? []).map((person) =>
        CareersPersonSerializer(person),
      ),
      careersTemplates: (data?.templates ?? []).map((template) =>
        LocalizationSerializer(template),
      ),
    }
  }
}
